var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"app-counter",attrs:{"data-jest":"app-counter"}},[_vm._v("\n  "+_vm._s(_vm.total)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }